export default __webpack_public_path__ + "static/media/tongzhoumu.53dc2fe1.jpg";